import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/newsreader/wght.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LabPage } from './pages/LabPage';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabPage />
  </StrictMode>,
);
